// Shared by V3ScoreBar (mobile) and V3ScoreCard (desktop).
export function computeFillPercent(value: number, max: number, isRatingSuspended: boolean): number {
  if (isRatingSuspended || max <= 0) return 0;
  return Math.min(100, (value / max) * 100);
}
